import React, {useState, useCallback, useEffect, useMemo, useRef} from "react";
import {Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import {Link, useNavigate} from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Breadcrumbs,
  Typography,
} from "@mui/material";
import {MdDelete, MdModeEdit} from "react-icons/md";
import {
  AGENT_CLIENTS,
  AGENT_DIA_PROPOSAL_LIST,
  DELETE_DIA_PROPOSAL,
  DIA_PROPOSAL_LIST,
} from "../../../constants/apiConstant";
import {useDispatch, useSelector} from "react-redux";
import {selectAuthState, setAuthData} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {initialFormValidations, removeCookies} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {selectUiState, setUiData} from "../../../store/uiSlice";
import GlobalModal from "../../global-fields/GlobalModal";
import {BsExclamationCircle} from "react-icons/bs";
import NoDataComponent from "../../no-data";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

const columns = [
  {id: "id", label: "#", minWidth: 25},
  {id: "proposal_id", label: "Proposal Number", minWidth: 110},
  {id: "created_at", label: "Date", minWidth: 170},
  {id: "name", label: "Company Name", minWidth: 170},
  {id: "actions", label: "Actions", minWidth: 160},
];
const agentColumns = [
  {id: "id", label: "#", minWidth: 25},
  {id: "full_name", label: "Client Name", minWidth: 150},
  {id: "proposal_id", label: "Proposal Number", minWidth: 110},
  {id: "created_at", label: "Date", minWidth: 170},
  {id: "name", label: "Company Name", minWidth: 170},
  {id: "actions", label: "Actions", minWidth: 160},
];

const rows = Array.from({length: 10}, (_, index) => ({
  id: index + 1,
  proposal_id: `PROP010120XX-${index + 1}`,
  created_at: "01/01/20XX XX:XX AM",
  name: "Associated International Brokers, Inc",
}));

const PR_ProposalUnderProgess = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isFirstRender = useRef(true);
  const {user} = useSelector(selectAuthState);
  const {showLoader} = useSelector(selectUiState);
  const {pendingProposalsData, pendingProposalsCount} =
    useSelector(selectDataStoreState);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);

  const proposalList = useMemo(
    () => (pendingProposalsData?.length ? pendingProposalsData : []),
    [pendingProposalsData]
  );

  const [proposalType, setProposalType] = useState("jewelers_block");

  const handleProposalChange = (event, newProposalType) => {
    setProposalType(newProposalType);
    if (newProposalType === "jewelers_block") {
      fetchProposals();
    } else {
    }
  };

  //const proposalList = pendingProposalsData || [];

  // console.log("proposalList", pendingProposalsData, proposalList);

  const fetchProposals = useCallback(async () => {
    if (page === null || rowsPerPage === null) return;

    dispatch(setUiData({showLoader: true}));

    let data = {
      limit: rowsPerPage,
      offset: page * rowsPerPage,
    };

    let apiDetails = {
      method: DIA_PROPOSAL_LIST.method,
      headers: DIA_PROPOSAL_LIST.headers,
      url: DIA_PROPOSAL_LIST.url,
    };

    if (user?.user_type === "agent") {
      data.agent_id = user?.id;
      apiDetails = {
        method: AGENT_DIA_PROPOSAL_LIST.method,
        headers: AGENT_DIA_PROPOSAL_LIST.headers,
        url: AGENT_DIA_PROPOSAL_LIST.url,
      };
    } else {
      data.user_id = user?.id;
    }
    const options = {
      method: apiDetails.method,
      headers: apiDetails.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(apiDetails.url, options);
      const res = await response.json();

      if (res.status == 1) {
        dispatch(
          setDataStore({
            pendingProposalsData: res?.diamond_list || [],
            pendingProposalsCount: res?.total_count || 0,
          })
        );
      } else {
        console.error("Error fetching proposals");
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error});
      navigate("/");
    } finally {
      dispatch(setUiData({showLoader: false}));
    }
  }, [user, page, rowsPerPage, dispatch, navigate]);

  useEffect(() => {
    fetchProposals();
  }, [fetchProposals, page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // const setRowsPerPageFn = (dt) => {
  //   setRowsPerPage(dt);
  //   setPage(0);
  // };

  const clientSearch = async (searchTerm,company_name,user_id) => {
    if (page === null || rowsPerPage === null) return;

    dispatch(setUiData({showLoader: true}));

    const data = {
      agent_id: user?.id,
      limit: 10,
      offset: 0,
      search: searchTerm,
      company:company_name,
      user_id:user_id
    };

    const options = {
      method: AGENT_CLIENTS.method,
      headers: AGENT_CLIENTS.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(AGENT_CLIENTS.url, options);
      const res = await response.json();

      dispatch(setUiData({showLoader: false}));

      if (res.status == 1) {
        return res?.user_list?.[0] ?? null;
      } else {
        GlobalNotificationPopup({type: "error", message: res?.message});
        return null;
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error});
      console.error("Error:", error);
      dispatch(setUiData({showLoader: false}));
      navigate("/");
      return null;
    }
  };

  const handleEdit = async (row) => {
    GlobalNotificationPopup({
      type: "info",
      message: "Coming soon..",
    });
    return;
    if (user?.user_type === "agent") {
      const client_ = await clientSearch(row.full_name,row.firm_name,row.user_id);
      if (client_) {
        dispatch(setAuthData({selectedClient: client_}));
      } else {
        GlobalNotificationPopup({
          type: "error",
          message: "Client Details Not Found!",
        });
        return;
      }
    }
    // console.log("ROWWWW",row)
    // return;
    // const updatedFormValidations = initialFormValidations.map((item) => {
    //   const key = Object.keys(item)[0]; // e.g., "s1"
    //   const value = item[key];
    //   const index = parseInt(key.replace("s", "")); // e.g., 1
    //   if (index <= row.current_step - 1) {
    //     return {[key]: 1};
    //   }
    //   return item;
    // });
    dispatch(
      setDataStore({
        proposalStep: row.current_step,
        proposal_id: row.proposal_id,
        //formValidations: initialFormValidations,
        // formValidations: updatedFormValidations,
      })
    );
    navigate("/new-proposal");
  };
  const handleDelete = async (row) => {
    setCurrentRow(row);
    setDeleteConfirmModal(true);
  };
  // const deleteProposal = async (row) => {
  //   dispatch(setUiData({ showLoader: true }));

  //   let data = {
  //     user_id: user?.id,
  //     proposal_id: row.proposal_id,
  //   };

  //   const options = {
  //     method: DELETE_DIA_PROPOSAL.method,
  //     headers: DELETE_DIA_PROPOSAL.headers,
  //     body: JSON.stringify(data),
  //   };

  //   try {
  //     const response = await fetch(DELETE_DIA_PROPOSAL.url, options);
  //     const res = await response.json();
  //     if (res.status == 1) {
  //       GlobalNotificationPopup({ type: "success", message: res.message });
  //       handleChangeRowsPerPage(10);
  //       // dispatch(
  //       //   setDataStore({
  //       //     pendingProposalsData: res?.proposal_list || [],
  //       //     pendingProposalsCount: res?.total_count || 0,
  //       //   })
  //       // );
  //     } else {
  //       console.error("Error fetching proposals");
  //     }
  //     dispatch(setUiData({ showLoader: false }));
  //   } catch (error) {
  //     removeCookies("isLogin");
  //     GlobalNotificationPopup({ type: "error", message: error });
  //     dispatch(setUiData({ showLoader: false }));
  //     navigate("/");
  //   }
  // }
  const deleteProposal = useCallback(async () => {
    if (!currentRow) return;
    dispatch(setUiData({showLoader: true}));

    let data = {
      proposal_id: currentRow?.proposal_id,
    };

    if (user?.user_type === "agent") {
      data = {...data, user_id: currentRow?.user_id};
    } else {
      data = {...data, user_id: user?.id};
    }

    const options = {
      method: DELETE_DIA_PROPOSAL.method,
      headers: DELETE_DIA_PROPOSAL.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(DELETE_DIA_PROPOSAL.url, options);
      const res = await response.json();

      if (res.status == 1) {
        GlobalNotificationPopup({type: "success", message: res.message});
        fetchProposals();
        setDeleteConfirmModal(false);
      } else {
        console.error("Error deleting proposal");
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error.message});
      navigate("/");
    } finally {
      dispatch(setUiData({showLoader: false}));
    }
  }, [currentRow]);

  const columns = [
    {
      id: "serial",
      label: "#",
      minWidth: 25,
      renderCell: (_row, value) => page * rowsPerPage + value + 1,
    },
    {id: "proposal_id", label: "Proposal Number", minWidth: 110},
    {id: "created_at", label: "Date", minWidth: 170},
    {id: "name", label: "Company Name", minWidth: 170},
    {id: "full_name", label: "Client Name", minWidth: 150},

    {
      id: "actions",
      label: "Actions",
      minWidth: 160,
      renderCell: (row) => (
        <>
          <Button
            onClick={() => handleEdit(row)}
            variant="contained"
            color="primary"
            size="small"
            style={{marginRight: 8, background: "#004F71"}}
          >
            <MdModeEdit /> Edit
          </Button>
          <Button
            onClick={() => handleDelete(row)}
            variant="contained"
            sx={{background: "#004f71"}}
            size="small"
          >
            <MdDelete /> Delete
          </Button>
        </>
      ),
    },
  ];

  const agentColumns = [
    {
      id: "serial",
      label: "#",
      minWidth: 25,
      renderCell: (_row, value) => page * rowsPerPage + value + 1,
    },
    {id: "name", label: "Company Name", minWidth: 170},
    { id: "full_name", label: "Client Name", minWidth: 150 },
    {id: "proposal_id", label: "Proposal Number", minWidth: 110},
    {id: "created_at", label: "Proposal Date", minWidth: 170},
    {id: "updated_at", label: "Last Updated Date", minWidth: 170},
   
    {
      id: "actions",
      label: "Actions",
      minWidth: 160,
      renderCell: (row) => (
        <>
          <Button
            onClick={() => handleEdit(row)}
            variant="contained"
            color="primary"
            size="small"
            style={{marginRight: 8, background: "#004F71"}}
          >
            <MdModeEdit /> Edit
          </Button>
          <Button
            onClick={() => handleDelete(row)}
            variant="contained"
            sx={{background: "#004f71"}}
            size="small"
          >
            <MdDelete /> Delete
          </Button>
        </>
      ),
    },
  ];

  useEffect(() => {
    const paginationInputs = document.querySelectorAll(
      ".MuiSelect-nativeInput"
    );
    paginationInputs.forEach((input, index) => {
      // Add aria-label only if not already present
      if (!input.hasAttribute("aria-label")) {
        input.setAttribute("aria-label", `Page number input ${index + 1}`);
      }
    });
  }, []);

  return (
    <>
      <Paper className={style.propTableMain}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {(user?.user_type === "agent" ? agentColumns : columns).map(
                  (column) => (
                    <TableCell
                      style={{minWidth: column.minWidth}}
                      key={column.id}
                    >
                      {column.label}
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            {proposalList?.length > 0 ? (
              <TableBody>
                {proposalList.map((row, idx) => (
                  <TableRow key={row.proposal_id}>
                    {(user?.user_type === "agent" ? agentColumns : columns).map(
                      (column) => (
                        <TableCell key={column.id}>
                          {column.renderCell
                            ? column.renderCell(row, idx)
                            : row[column.id]}
                        </TableCell>
                      )
                    )}
                  </TableRow>
                ))}
              </TableBody>
            ) : null}
          </Table>
          {proposalList?.length > 0 ? null : !showLoader && <NoDataComponent />}
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 15]}
          component="div"
          count={pendingProposalsCount || 0} // Use correct count
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          disabled={proposalList?.length <= 0}
        />
      </Paper>

      <GlobalModal
        open={deleteConfirmModal}
        // open={true}
        maxWidth="xs"
        handleClose={() => setDeleteConfirmModal(false)}
        aria-labelledby="claim-history"
        closeIcon={true}
        title={"Are you Sure?"}
        dialogTitleClass={style.claimPopTitle}
        disableBackdropClick={false}
        dialogContent={
          <Grid container spacing={0}>
            <Grid
              size={{xs: 12, md: 12}}
              sx={{mb: 3, mt: 1}}
              textAlign={"center"}
            >
              <BsExclamationCircle size={60} color="#c62828" />
              <p style={{marginTop: 12, fontWeight: 600}}>
                You Want To Delete This Proposal?
              </p>
            </Grid>
            <Grid
              size={{xs: 12, md: 12}}
              sx={{textAlign: "center"}}
              className={style.consentContentBtn}
            >
              <Button
                style={{backgroundColor: "#c62828"}}
                variant="contained"
                sx={{mr: 1}}
                onClick={deleteProposal}
              >
                <MdDelete size={20} style={{marginRight: 5}} /> Delete
              </Button>
              <Button
                variant="contained"
                onClick={() => setDeleteConfirmModal(false)}
              >
                No
              </Button>
            </Grid>
          </Grid>
        }
      />
    </>
  );
};

export default PR_ProposalUnderProgess;
